export const HOME = {
  emergentLink: "home-emergent-link",
  hero: "home-hero",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  services: "home-services",
  gallery: "home-gallery",
  clients: "home-clients",
  contact: "home-contact",
  whatsappFab: "whatsapp-fab",
};
export const ADMIN = {
  loginUser: "admin-login-user",
  loginPw: "admin-login-password",
  loginSubmit: "admin-login-submit",
  navContent: "admin-tab-content",
  navServices: "admin-tab-services",
  navPhotos: "admin-tab-photos",
  navClients: "admin-tab-clients",
  navSecurity: "admin-tab-security",
  logout: "admin-logout",
};
